<template>
  <v-dialog :fullscreen="!$vuetify.breakpoint.smAndUp" :value="dialog" max-width="910" @click:outside="closeDialog"
    @keydown.esc="closeDialog" scrollable>
    <v-card v-if="selectedBundle" :disabled="loading" :loading="loading || $wait.is('loading userBehavior createOrUpdateUserBehaviors')
      ">
      <v-card-title class="pa-0">
        <v-toolbar color="primary">
          <div class="title font-weight-medium" style="color: white">
            Hvor vil du hente produktet?
          </div>
          <v-spacer />
          <v-btn icon @click="closeDialog">
            <v-icon color="white">close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-data-table style="width:100%" :class="'table__breakpoint_' + $vuetify.breakpoint.name" :headers="headers"
          :items="salons" disable-sort hide-default-footer light mobile-breakpoint="875" :items-per-page="salons.length">
          <template v-slot:item.siteName="{ item }">
            <div class="my-auto">
              <div :class="{ title: $vuetify.breakpoint.smAndUp }" class="font-weight-bold text-no-wrap">
                {{ item.siteName }}
              </div>
              <div :style="{
                'font-size': $vuetify.breakpoint.smAndUp ? '16px' : 'inherit'
              }" class="text-capitalize overflow-hidden text-no-wrap" style="text-overflow: ellipsis">
                {{ item.address.toLowerCase() }},
                {{ item.postalArea.toLowerCase() }} {{ item.postalCode }}
              </div>
              <div>
                <small v-if="item.distanceFromLocationInMeters" class="text--secondary">
                  ({{ formatDistance(item.distanceFromLocationInMeters) }})
                </small>
              </div>
            </div>
          </template>
          <template v-slot:item.stock="{ item }">
            <div :class="{ 'error--text': !getBundleStockAmountForSite(item) }" :style="{
              'font-size': $vuetify.breakpoint.smAndUp ? '16px' : 'inherit'
            }" class="text-center my-auto">
              {{
                getBundleStockAmountForSite(item) ? "På lager" : "Ikke på lager"
              }}
            </div>
          </template>
          <template v-slot:item.price="{ item }">
            <div>
              <div class="align-self-center" v-if="selectedBundle.totalValue === selectedBundle.campaignValue
                ">
                <span class="font-weight-regular">kr </span>
                <span class="font-weight-medium" style="font-size: 20px">{{ selectedBundle.totalValue | currency(2, 2) }}
                </span>
              </div>
              <div class="align-self-center" v-else>
                <span style="color: red" class="text-decoration-line-through font-weight-regular">kr
                  <small style="font-size: 14px">{{ selectedBundle.totalValue | currency(2, 2) }}
                  </small></span><br />
                <span class="font-weight-regular">kr </span>
                <span class="font-weight-medium" style="font-size: 20px">{{ selectedBundle.campaignValue | currency(2, 2)
                }}
                </span>
              </div>
            </div>
          </template>
          <template v-slot:item.action="{ item }">
            <div class="d-flex justify-center fill-height my-auto">
              <div class="mx-9 align-self-center" style="position: relative; min-width: 36px">
                <div v-if="getCartProductCounts(item.siteId)">
                  <v-icon :size="$vuetify.breakpoint.smAndUp ? 30 : 28">shopping_cart</v-icon>
                  <v-badge :content="getCartProductCounts(item.siteId)" color="red"
                    style="position: absolute; right: 7px; top: 3px"></v-badge>
                </div>
              </div>
              <v-btn :disabled="$wait.is(
                'loading userBehavior createOrUpdateUserBehaviors'
              ) ||
                outOfStock(item) ||
                maximumAdded(item)
                " :loading="$wait.is(
    `loading clickAndCollect addBundleToCart ${selectedBundle.campaignId} ${item.siteId}`
  )
    " class="white--text align-self-center" color="primary" outlined @click="addBundleToSalonCart(item)">
                Velg
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import cloneDeep from "lodash.clonedeep";
import { getCurrentLocation } from '@fixit/fixit-no-header/src/utils/location'
import webshopMixins from "@/components/webshop/cart/webshop.mixins";
import orderBy from "lodash-es/orderBy";

export default {
  data() {
    return {
      headers: [
        { text: "Salonger", value: "siteName" },
        { text: "Lagerstatus", value: "stock", align: "center", width: "15%" },
        { text: "Pris", value: "price", align: "end", width: "17%" },
        { text: "", value: "action", align: "center", sortable: false }
      ],
      lastLatitude: null,
      lastLongitude: null,
      loading: false
    };
  },
  mixins: [webshopMixins],
  props: {
    dialog: Boolean
  },
  created() {
  },
  methods: {
    getCartProductCounts(siteId) {
      return this.carts.find(x => x.siteId === siteId)?.productCount || 0;
    },

    outOfStock() {
      return (
        this.selectedBundle.subscriptions &&
        !this.selectedBundle.subscriptions.length
      );
    },

    maximumAdded(item) {
      var cartBundle = this.cartBundles.find(
        bundle =>
          parseInt(bundle.id) === this.selectedBundle.campaignId &&
          bundle.siteId === item.siteId
      );
      if (cartBundle) {
        return (
          this.getBundleStockAmountForSite(item) === cartBundle.quantity ||
          cartBundle.quantity === cartBundle.maxPerCustomer
        );
      }
    },

    async closeDialog(goToBundleDetails) {
      await this.$store.dispatch("webshop/set", {
        key: "bundleSalonPickOptions",
        value: { dialog: false }
      });
      if (goToBundleDetails === true)
        this.$router.push({
          name: "webshopCampaignBundle",
          params: {
            campaignId: this.selectedBundle.campaignId
          }
        });
    }
  },
  computed: {
    formatDistance() {
      return distance =>
        distance >= 1000
          ? `${(distance / 1000).toFixed(2)} km`
          : `${distance} m`;
    },

    salons() {
      let salons = cloneDeep(
        this.$store.getters["webshop/get"]("settings")?.activatedSalons || []
      ).map(x =>
        this.lastLatitude && this.lastLongitude
          ? Object.assign(x, {
            distanceFromLocationInMeters: parseInt(
              x.getDistanceFromLatLonInKm(
                this.lastLatitude,
                this.lastLongitude
              ) * 1000
            )
          })
          : x
      );

      return orderBy(salons, site => this.getBundleStockAmountForSite(site), [
        "desc"
      ]);
    }
  },
  watch: {
    async dialog(v) {
      if (v) {
        this.loading = true;
        this.lastLatitude = localStorage.getItem("lastLatitude");
        this.lastLongitude = localStorage.getItem("lastLongitude");
        if (!this.lastLatitude && !this.lastLongitude) {
          let result = await getCurrentLocation(this);
          if (!result.denied && result.geometry) {
            localStorage.setItem("lastLatitude", result.geometry.location.lat);
            localStorage.setItem("lastLongitude", result.geometry.location.lng);
            this.lastLatitude = result.geometry.location.lat;
            this.lastLongitude = result.geometry.location.lng;
          }
        }
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.v-card__title {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: white;
}

.v-data-table::v-deep {
  table {
    table-layout: fixed;
  }

  thead {
    tr {
      height: 0 !important;

      th {
        height: 0 !important;
        background-color: transparent !important;
      }
    }
  }

  .v-data-table__mobile-row__header {
    padding-right: 15px;
  }

  .v-data-table-header-mobile tr th {
    width: 100%;
  }

  .v-data-table__mobile-row {
    padding: 0 10px;
  }

  .v-data-table__mobile-row__cell {
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  tr:not(.v-data-table__mobile-table-row) {
    height: 65px;
  }

  td {
    padding: 30px 10px;
  }

  th {
    background-color: var(--v-primary-base) !important;
    color: white !important;
  }
}

.v-data-table.table__breakpoint_xs::v-deep {
  td.v-data-table__mobile-row:first-child {
    height: 64px;
  }

  td.v-data-table__mobile-row:last-child {
    height: 55px;
  }
}

.v-data-table.table__breakpoint_sm::v-deep {
  td.v-data-table__mobile-row:first-child {
    height: 74px;
  }

  td.v-data-table__mobile-row:last-child {
    height: 65px;
  }
}
</style>
